// src/components/SuccessModal.js
import React, { useEffect, useState } from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import './SuccessModal.css';

const SuccessModal = ({
    open,
    title = '¡Éxito!',
    message = 'Operación completada correctamente',
    duration = 6000, // 6 segundos por defecto
    onClose,
}) => {
    const [progreso, setProgreso] = useState(100);

    useEffect(() => {
        if (!open) {
            setProgreso(100);
            return;
        }

        // Cerrar automáticamente después de 'duration' ms
        const timer = setTimeout(() => {
            if (onClose) {
                onClose();
            }
        }, duration);

        // Animar la barra de progreso
        const intervalo = 50; // Actualizar cada 50ms
        const decremento = (100 / duration) * intervalo;
        
        const progressTimer = setInterval(() => {
            setProgreso((prev) => {
                const nuevo = prev - decremento;
                return nuevo > 0 ? nuevo : 0;
            });
        }, intervalo);

        return () => {
            clearTimeout(timer);
            clearInterval(progressTimer);
        };
    }, [open, duration, onClose]);

    if (!open) return null;

    return (
        <div className="success-modal-overlay">
            <div className="success-modal">
                <div className="success-modal-icon-container">
                    <FaCheckCircle className="success-modal-icon" />
                </div>
                
                <h3 className="success-modal-title">{title}</h3>
                <p className="success-modal-message">{message}</p>
                
                <div className="success-modal-progress-bar">
                    <div 
                        className="success-modal-progress-fill" 
                        style={{ width: `${progreso}%` }}
                    />
                </div>
                
                <button 
                    className="success-modal-close-btn"
                    onClick={onClose}
                >
                    Cerrar
                </button>
            </div>
        </div>
    );
};

export default SuccessModal;

